export const Data = [
    {
        "id": "1",
        "category": "Nike",
        "name": "Nike Air Force 1 ",
        "price": "75.000 ",
        "size": "32-40 ",
        "description": "Tallas Desde La 32 A La 40",
        "url": "air-force-one",
        "img": "air-force-one.png"
      },
  
      {
        "id": "2",
        "category": "Adidas",
        "name": "Adidas Blue M ",
        "price": "75.000 ",
        "size": "33-38 ",
        "description": "Tallas Desde La 33 A La 38",
        "url": "adidas",
        "img": "adidas.png"
      },
  
      {
        "id": "3",
        "category": "Nike",
        "name": "Nike Jordan 1 ",
        "price": "120.000 ",
        "size": "36-42 ",
        "description": "Tallas Desde La 36 A La 42",
        "url": "jordan-one",
        "img": "jordan-one.png"
      },
  
      {
        "id": "4",
        "category": "Nike",
        "name": "Jordan Low ",
        "price": "120.000 ",
        "size": "31-36 ",
        "description": "Tallas Desde La 31 A La 36",
        "url": "jordan-one-low",
        "img": "jordan-one-low.png"
      },
  
      {
        "id": "5",
        "category": "Adidas",
        "name": "Adidas Smith ",
        "price": "80.000 ",
        "size": "35-40 ",
        "description": "Tallas Desde La 35 A La 40",
        "url": "adidas-smith",
        "img": "adidas-smith.png"
      },
  
      {
        "id": "6",
        "category": "Nike",
        "name": "Nike Air Force 1 ",
        "price": "75.000 ",
        "size": "31-37 ",
        "description": "Tallas Desde La 31 A La 37",
        "url": "air-force-one",
        "img": "air-force-1.png"
      },
  
      {
        "id": "7",
        "category": "Nike",
        "name": "Nike Air Max 270 ",
        "price": "70.000 ",
        "size": "34-42 ",
        "description": "Tallas Desde La 34 A La 42",
        "url": "air-max",
        "img": "air-max-270.png"
      },
  
      {
        "id": "8",
        "category": "Adidas",
        "name": "Adidas Pink M ",
        "price": "70.000 ",
        "size": "32-38 ",
        "description": "Tallas Desde La 32 A La 38",
        "url": "adidas",
        "img": "adidas-mujer.png"
      },
  
      {
        "id": "9",
        "category": "Nike",
        "name": "Nike Jordan 3 ",
        "price": "150.000 ",
        "size": "35-41 ",
        "description": "Tallas Desde La 35 A La 41",
        "url": "jordan-3",
        "img": "jordan-3.png"
      },
  
      {
        "id": "10",
        "category": "Adidas",
        "name": "Adidas Original ",
        "price": "80.000 ",
        "size": "34-37 ",
        "description": "Tallas Desde La 34 A La 37",
        "url": "adidas",
        "img": "adidas-original.png"
      },
  ];